import { Link } from '@tanstack/react-router';
import { AlertTriangle } from 'lucide-react';
import { useErrorText, useT } from '../i18n';

/**
 * Last line of defence: an unexpected failure anywhere in the tree shows this
 * instead of a blank page, and still never exposes technical detail (§29).
 */
export const RouteErrorPage = ({ error }: { error: unknown }) => {
  const { t } = useT();
  const { errorText } = useErrorText();

  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-2 px-6 py-20 text-center">
      <AlertTriangle className="size-6 text-fail" />
      <p className="text-[15px] font-semibold text-ink">{t('common.somethingWentWrong')}</p>
      <p className="max-w-md text-[13px] text-ink-muted">
        {errorText(error, 'error.renderFailed')}
      </p>
      <div className="mt-3 flex items-center gap-2">
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-md border border-border bg-surface px-3.5 py-2 text-[13px] font-medium text-ink hover:bg-sunken"
        >
          {t('error.reload')}
        </button>
        <Link
          to="/"
          className="rounded-md bg-accent px-3.5 py-2 text-[13px] font-medium text-white hover:bg-accent-hover"
        >
          {t('error.backToDashboard')}
        </Link>
      </div>
    </div>
  );
};
